import { Action } from "redux"

export const INITIALIZE = "NAVIGATION_INITIALIZE"
export const SET_INITIALIZED = "NAVIGATION_SET_INITIALIZED"
export const FILTER_WORKSPACES = "NAVIGATION_FILTER_WORKSPACES"
export const RECEIVE_WORKSPACES = "NAVIGATION_RECEIVE_WORKSPACES"
export const REQUEST_WORKSPACES = "NAVIGATION_REQUEST_WORKSPACES"
export const FILTER_SMARTLISTS = "NAVIGATION_FILTER_SMARTLISTS"
export const REQUEST_SMARTLISTS = "NAVIGATION_REQUEST_SMARTLISTS"
export const RECEIVE_SMARTLISTS_PRIVATE =
    "NAVIGATION_RECEIVE_SMARTLISTS_PRIVATE"
export const REQUEST_SMARTLISTS_PRIVATE =
    "NAVIGATION_REQUEST_SMARTLISTS_PRIVATE"
export const RECEIVE_SMARTLISTS_SHARED_BY_ME =
    "NAVIGATION_RECEIVE_SMARTLISTS_SHARED_BY_ME"
export const REQUEST_SMARTLISTS_SHARED_BY_ME =
    "NAVIGATION_REQUEST_SMARTLISTS_SHARED_BY_ME"
export const RECEIVE_SMARTLISTS_SHARED_WITH_ME =
    "NAVIGATION_RECEIVE_SMARTLISTS_SHARED_WITH_ME"
export const REQUEST_SMARTLISTS_SHARED_WITH_ME =
    "NAVIGATION_REQUEST_SMARTLISTS_SHARED_WITH_ME"
export const UPDATE_SELECTED_TAB = "NAVIGATION_UPDATE_SELECTED_TAB"

export interface Load extends Action {
    filter: string
    offset: number
    limit: number
}

export interface ReceiveWorkspacesAny extends Action {
    workspaces: Models.NavigationWorkspace[]
    offset: number
    hasMore: boolean
}

export interface FilterWorkspacesAny extends Action {
    filter: string
}

export interface FilterSmartlists extends Action {
    filter: string
}

export interface ReceiveSmartlistsGeneric extends Action {
    smartlists: Models.Smartlist[]
    offset: number
    hasMore: boolean
}

export interface TabAction extends Action {
    tab: number
}

export const initializeNavigation = (tab: number): TabAction => ({
    type: INITIALIZE,
    tab,
})

export const setInitialized = (): Action => ({ type: SET_INITIALIZED })

export const requestWorkspacesFull = (): Action => ({
    type: REQUEST_WORKSPACES,
})

export const receiveWorkspacesFull = (
    workspaces: Models.NavigationWorkspace[],
    offset: number,
    hasMore: boolean,
): ReceiveWorkspacesAny => ({
    type: RECEIVE_WORKSPACES,
    workspaces,
    offset,
    hasMore,
})

export const filterWorkspacesFull = (filter: string): FilterWorkspacesAny => ({
    type: FILTER_WORKSPACES,
    filter,
})

export const requestSmartlists = (): Action => ({ type: REQUEST_SMARTLISTS })

export const filterSmartlists = (filter: string): FilterSmartlists => ({
    type: FILTER_SMARTLISTS,
    filter,
})

export const requestSmartlistsPrivate = (): Action => ({
    type: REQUEST_SMARTLISTS_PRIVATE,
})

export const receiveSmartlistsPrivate = (
    smartlists: Models.Smartlist[],
    offset: number,
    hasMore: boolean,
): ReceiveSmartlistsGeneric => ({
    type: RECEIVE_SMARTLISTS_PRIVATE,
    smartlists,
    offset,
    hasMore,
})

export const requestSmartlistsSharedByMe = (): Action => ({
    type: REQUEST_SMARTLISTS_SHARED_BY_ME,
})

export const receiveSmartlistsSharedByMe = (
    smartlists: Models.Smartlist[],
    offset: number,
    hasMore: boolean,
): ReceiveSmartlistsGeneric => ({
    type: RECEIVE_SMARTLISTS_SHARED_BY_ME,
    smartlists,
    offset,
    hasMore,
})

export const requestSmartlistsSharedWithMe = (): Action => ({
    type: REQUEST_SMARTLISTS_SHARED_WITH_ME,
})

export const receiveSmartlistsSharedWithMe = (
    smartlists: Models.Smartlist[],
    offset: number,
    hasMore: boolean,
): ReceiveSmartlistsGeneric => ({
    type: RECEIVE_SMARTLISTS_SHARED_WITH_ME,
    smartlists,
    offset,
    hasMore,
})

export const updateSelectedTab = (tab: number): TabAction => ({
    type: UPDATE_SELECTED_TAB,
    tab,
})

export const mapDispatchToProps = {
    initializeNavigation,
    requestWorkspacesFull,
    filterWorkspacesFull,
    requestSmartlists,
    filterSmartlists,
    requestSmartlistsPrivate,
    requestSmartlistsSharedByMe,
    requestSmartlistsSharedWithMe,
    updateSelectedTab,
}

export type DispatchProps = typeof mapDispatchToProps
